import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-company-details-event-data',
  templateUrl: './company-details-event-data.component.html',
  styleUrls: ['./company-details-event-data.component.scss'],
})
export class CompanyDetailsEventDataComponent {
  @Input() company_id?: string | null;
  is_read_running = true;

  ngOnInit(): void {
    this.listCompanyEvent(this.company_id as string);
  }

  onRefresh(): void {
    this.listCompanyEvent(this.company_id as string);
  }

  listCompanyEvent(company_id?: string): void {
    this.is_read_running = true;

    if (company_id) {
      this.is_read_running = false;
    }
  }
}
